import { render, staticRenderFns } from "./postdoctorReward.vue?vue&type=template&id=6d402acf&scoped=true&"
import script from "./postdoctorReward.vue?vue&type=script&lang=js&"
export * from "./postdoctorReward.vue?vue&type=script&lang=js&"
import style0 from "./postdoctorReward.vue?vue&type=style&index=0&id=6d402acf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d402acf",
  null
  
)

export default component.exports